import { render, staticRenderFns } from "./InputTransformer.vue?vue&type=template&id=6c134efa&scoped=true&"
import script from "./InputTransformer.vue?vue&type=script&lang=js&"
export * from "./InputTransformer.vue?vue&type=script&lang=js&"
import style0 from "./InputTransformer.vue?vue&type=style&index=0&id=6c134efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c134efa",
  null
  
)

export default component.exports